import { Apple, Footprints, Leaf, PawPrint } from "lucide-react";

const GONE = [50, 84, 1.25];

const Log = () => (
  <svg viewBox="0 0 140 40" className="absolute left-1/2 top-[62%] w-[150%] -translate-x-1/2" aria-hidden>
    <rect x="4" y="10" width="132" height="24" rx="12" fill="#7A4E2A" /><rect x="4" y="10" width="132" height="9" rx="4.5" fill="#9C6A3E" />
    <ellipse cx="128" cy="22" rx="8" ry="12" fill="#C9935A" /><ellipse cx="128" cy="22" rx="4" ry="6" fill="none" stroke="#7A4E2A" strokeWidth="1.6" />
    <path d="M40 10 q6 -9 14 -8" stroke="#3E9F6E" strokeWidth="4" fill="none" strokeLinecap="round" />
  </svg>
);

const Print = ({ i, slot, slots, active, reached, side, obstacle, variant }) => {
  const [x, y, s] = slot === -1 ? GONE : slots[slot];
  const Icon = variant === "stone" || variant === "plank" ? Footprints : variant === "fruit" ? (i % 2 ? Leaf : Apple) : PawPrint;
  return (
    <div data-testid={`footprint-${i}`} data-active={active} className="absolute transition-[left,top,transform,opacity] duration-700 ease-out"
      style={{ left: `${x}%`, top: `${y}%`, transform: `translate(-50%,-50%) scale(${s})`, opacity: slot === -1 ? 0 : 1 - slot * 0.12 }}>
      {variant !== "paw" && active && <span className="ring-wave absolute -inset-3 rounded-[50%] border-2 border-white/80" />}
      <div className={`relative flex h-[62px] w-[104px] items-center justify-center rounded-[50%] border-[3px] ${reached ? "border-[#FFE29A] bg-[#E0B33A]/80" : variant === "stone" ? "border-[#B8FFF6] bg-[#5E7B86]/60" : variant === "fruit" ? "border-[#FFE29A] bg-[#2BA36B]/60" : variant === "plank" ? "border-[#FFE29A] bg-[#8B5A2B]/75" : "border-[#B8FFF6] bg-[#17A2A2]/55"} ${active ? "fp-pulse shadow-[0_0_34px_10px_rgba(79,209,197,.75)]" : "shadow-[0_0_14px_2px_rgba(79,209,197,.45)]"}`}>
        <Icon className={`h-9 w-9 ${variant === "stone" || variant === "plank" ? "" : "fill-white"} text-white ${side === "left" ? "-scale-x-100" : ""}`} />
        <span className="absolute -right-1 -top-2 rounded-full bg-[#0A2540] px-1.5 text-[10px] font-extrabold text-white">{side === "left" ? "G" : "D"}</span>
        {active && obstacle && <Log />}
      </div>
    </div>
  );
};

export const Trail = ({ reps, current, reached, sideOf, obstacle, slots, variant = "paw" }) => (
  <div className="pointer-events-none absolute inset-0" data-testid="savanna-trail">
    {Array.from({ length: reps }, (_, i) => {
      const slot = i - current;
      if (slot < -1 || slot >= slots.length) return null;
      return <Print key={i} i={i} slot={slot} slots={slots} variant={variant} active={slot === 0} reached={slot === 0 && reached} side={sideOf(i)} obstacle={obstacle} />;
    })}
  </div>
);
